import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatFormField, MatOption, MatSelect, MatSuffix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { ContactColumn } from '../../models/contacts-columns';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ContactType } from '../../models/contacts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
  selector: 'app-contact-filters',
  standalone: true,
  imports: [MatSelect, MatInput, MatFormField, MatIcon, MatSuffix, MatOption, ReactiveFormsModule],
  templateUrl: './contact-filters.component.html',
  styleUrl: './contact-filters.component.scss'
})
export class ContactFilters implements OnInit {
  @Input() columns: ContactColumn[] = [];
  @Output() filterApplied = new EventEmitter<{
    search?: { columnName: string | null; value: string };
    type?: ContactType | 'All';
  } | null>();
  readonly defaultContactType = 'All';
  selectedColumn = '';
  searchControl = new FormControl('', { nonNullable: true });
  contactTypeControl = new FormControl<ContactType | typeof this.defaultContactType>(this.defaultContactType, {
    nonNullable: true
  });

  private destroyRef = inject(DestroyRef);

  get searchPlaceholder(): string {
    const column = this.columns.find(c => c.key === this.selectedColumn);
    return column ? `Filter by ${column.label.toLowerCase()}...` : 'Search...';
  }

  ngOnInit() {
    this.contactTypeControl.valueChanges
      .pipe(
        tap(type => this.filterApplied.emit({ type })),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  search() {
    this.filterApplied.emit({
      search: {
        columnName: this.selectedColumn || null,
        value: this.searchControl.value || ''
      }
    });
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.search();
  }
}
